"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapKeys = wrapKeys;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function* wrapKeys(keysable) {
  if (keysable == null) {
    return (0, _iterable.empty)();
  } else {
    yield* keysable.keys();
  }
}

var _default = (0, _iterable.wrapWithMethodIterable)(wrapKeys);

exports.default = _default;